import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';

@Component({
  selector: 'app-ribbon-back-dialog',
  templateUrl: './ribbon-back-dialog.component.html',
  styleUrls: ['./ribbon-back-dialog.component.scss']
})
export class RibbonBackDialogComponent implements OnInit {
  @Input() valid:boolean = false;
  @Output() myClick =  new EventEmitter();
  
  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

  onClick(){
    this.myClick.emit();
  }

}
